import React from 'react';

function Icon(props) {
  return (
    <svg width="35" height="35" fill="none" viewBox="0 0 35 35">
      <rect width="35" height="35" fill={props.color} rx="17.5"></rect>
      <path fill="#fff" d="M24.14 12L26 13.86 15.579 24.28 10 18.703l1.86-1.86 3.719 3.72L24.14 12z"></path>
    </svg>
  );
}

export default Icon;
